// Persistent header entry point for the win-back FREE unlimited hour. Stays in
// the header for the whole session so a user who dismissed the welcome-back
// popup can still claim. Gold/amber (free reward) to read distinctly from the
// red paid "Bonus" teaser. Purely presentational — onClick re-opens the
// centralized reengagement modal in _app.tsx. Markup mirrors UnlimitedBonusTeaser
// (same proven -translate-y-[6px] alignment for this icon column).
export default function UnlimitedReengagementTeaser({
  onClick,
}: {
  onClick?: () => void;
}) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onClick?.()}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      }}
      aria-label="Claim your free unlimited hour"
      className="flex flex-col items-center cursor-pointer hover:scale-105 transform transition-transform duration-300"
    >
      <div className="relative flex h-9 items-center justify-center -translate-y-[6px]">
        <div className="relative h-9 w-8" aria-hidden>
          {/* bow — sits on the box's top edge */}
          <div className="absolute left-1/2 top-[2px] z-10 flex -translate-x-1/2 gap-[1px]">
            <span className="h-[7px] w-[6px] -rotate-[20deg] rounded-full bg-gradient-to-br from-amber-300 to-amber-500" />
            <span className="h-[7px] w-[6px] rotate-[20deg] rounded-full bg-gradient-to-bl from-amber-300 to-amber-500" />
          </div>
          {/* box + vertical ribbon, centered on the row line */}
          <div className="absolute inset-x-0 top-1/2 h-[22px] -translate-y-1/2 overflow-hidden rounded-[4px]
                          bg-gradient-to-b from-neutral-700 via-neutral-900 to-black
                          ring-1 ring-amber-400/50 shadow-[0_0_8px_rgba(251,191,36,0.5)]">
            <span className="absolute inset-y-0 left-1/2 w-[5px] -translate-x-1/2 bg-gradient-to-b from-amber-300 to-amber-500" />
          </div>
        </div>
        {/* attention dot */}
        <span className="absolute right-1 top-1.5 h-2 w-2 rounded-full bg-amber-300 ring-2 ring-headerBackground animate-pulse" />
      </div>
      <span className="hidden md:block text-amber-300 text-[0.5rem] -mt-0.5 font-semibold">
        Free hr
      </span>
    </div>
  );
}
